export default __webpack_public_path__ + "static/media/9.97a29c4b.jpg";